/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Button, Modal, Typography, Upload, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import legacyOtaServices from '../../../../services/legacy-ota.services';

const { Text } = Typography;

const FillBundleModal = ({ record, onClose, onSuccess }) => {
  const [androidFile, setAndroidFile] = useState(null);
  const [iosFile, setIosFile] = useState(null);

  const { mutate: updateOtaVersion, isLoading: isUploading } =
    legacyOtaServices.useMutationUpdateOtaVersion(
      () => {
        notification.success({
          message: 'เติมแพ็กเกจสำเร็จ',
          description: `v${record.version} ครบตามที่อัปแล้ว`,
        });
        onSuccess();
      },
      (error) => {
        notification.error({
          message: 'เติมแพ็กเกจไม่สำเร็จ',
          description: error?.message || error,
        });
      },
    );

  const needAndroid = record && !record.androidBundleUrl;
  const needIos = record && !record.iosBundleUrl;

  const submit = () => {
    const formData = new FormData();
    if (needAndroid && androidFile) {
      formData.append('androidBundle', androidFile);
    }
    if (needIos && iosFile) {
      formData.append('iosBundle', iosFile);
    }
    if (!formData.has('androidBundle') && !formData.has('iosBundle')) {
      notification.warning({ message: 'เลือกไฟล์ zip อย่างน้อย 1 ไฟล์' });
      return;
    }
    updateOtaVersion({ id: record.id, formData });
  };

  const handleClose = () => {
    setAndroidFile(null);
    setIosFile(null);
    onClose();
  };

  return (
    <Modal
      visible={!!record}
      title={`เติมแพ็กเกจให้ v${record?.version} (${record?.environment})`}
      okText="อัปโหลด"
      okButtonProps={{ loading: isUploading }}
      cancelText="ยกเลิก"
      zIndex={1080}
      onOk={submit}
      onCancel={handleClose}
    >
      <Text type="secondary">
        เติมได้เฉพาะฝั่งที่ยังว่างอยู่เท่านั้น — bundle ฝั่งที่มีแล้วให้ลบ
        version แล้วสร้างใหม่
      </Text>

      {needAndroid && (
        <div className="mt-3">
          <Text>
            Android zip (ยังไม่มี) <span style={{ color: 'red' }}>*</span>
          </Text>
          <Upload
            accept=".zip"
            maxCount={1}
            fileList={androidFile ? [androidFile] : []}
            beforeUpload={(file) => {
              setAndroidFile(file);
              return false;
            }}
            onRemove={() => setAndroidFile(null)}
          >
            <Button icon={<UploadOutlined />}>index.android.bundle.zip</Button>
          </Upload>
        </div>
      )}

      {needIos && (
        <div className="mt-3">
          <Text>
            iOS zip (ยังไม่มี) <span style={{ color: 'red' }}>*</span>
          </Text>
          <Upload
            accept=".zip"
            maxCount={1}
            fileList={iosFile ? [iosFile] : []}
            beforeUpload={(file) => {
              setIosFile(file);
              return false;
            }}
            onRemove={() => setIosFile(null)}
          >
            <Button icon={<UploadOutlined />}>main.jsbundle.zip</Button>
          </Upload>
        </div>
      )}
    </Modal>
  );
};

export default FillBundleModal;
